import React from "react";
import NumberFormat from "react-number-format";
import { Controller } from "react-hook-form";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
const NumberInput = ({
  placeholder = "",
  labelClass = "label-control",
  inputClass = "form-control input-sm",
  wrapperClass = "form-group",
  inputWrapClass = "col-md-8",
  labelText = "",
  starRed = "",
  inputProps = {},
  error,
  toolTip,
  textToolTip,
}) => {
  return (
    <div>
      <label className="label-control color7-bold"> 
        {labelText} <span className="canh-bao-red"  style={{ margin: "-5px 0 0 0", display: "inline-block" }}>{starRed}</span>
        {toolTip && (
          <PopoversBootrap
            contentText={textToolTip}
            titleText=""
            trigger={["hover", "focus"]}
            placement={"top"}
          >
            <i className="la la-question-circle tool-comment"></i>
          </PopoversBootrap>
        )}
      </label>
      <div>
        <Controller
          // as={NumberFormat}
          thousandSeparator
          prefix={""}
          name={inputProps.name}
          className={inputClass}
          control={inputProps.control}
          onChange={inputProps.onChange}
          value={inputProps.value}
          placeholder={placeholder}
          rules={inputProps.rules}
          defaultValue={inputProps.value}
          disabled={inputProps.disabled}
          readOnly={inputProps.readOnly}
          render={(props) => (
            <NumberFormat
              {...props}
              onChange={(value) => {
                props.onChange(value);
                inputProps.onChange(value);
              }}
              className={inputClass}
              thousandSeparator
              readOnly={inputProps.readOnly}
            />
          )}
        />
        {error && <span className="canh-bao-red">{error.message}</span>}
      </div>
    </div>
  );
};
export default NumberInput;
